import React, { PureComponent, PropTypes } from 'react';
import cn from 'classnames';
import styles from './styles.scss';

export class AnimatedTick extends PureComponent {
  render() {
    return (
      <div className={cn(this.props.className, styles.tickBackground)}>
        <svg className={styles.tick} fill="#FFFFFF" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
        </svg>
      </div>
    );
  }
}

AnimatedTick.propTypes = {
  className: PropTypes.string,
};

/**
 * default export
 */
export default AnimatedTick;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/animatedTick/index.jsx